/* rv-flavor-state: the page flavor (DESIGN-SYSTEM.md §2.3). Load globally, deferred, BEFORE the other rv-*.js.
   - Listens to "rv:flavor-change" on document, detail { handle, accent, deep, tint } (the buy box, hero chips,
     Short List toggle…). Writes --rv-flavor-accent/-deep/-tint on <html> and sets <html data-rv-flavor="<handle>|duo">.
     The Duo sends the first flavor's colors. Colors swap instantly (no transition here).
   - Remembers the pick for the visit (sessionStorage 'rv-flavor', try/catch) and restores it on the next page,
     so the shop page opens on the flavor picked on the homepage. Never on product pages: a PDP's flavor is its
     product (server-rendered). Pages opt out with <html data-rv-flavor-lock>; product templates are detected
     from Dawn's <main data-template>.
   - window.rvFlavor.set(detail) dispatches the event for components that don't build their own. */
(() => {
  const D = document;
  const R = D.documentElement;
  const K = 'rv-flavor';
  const T = ['accent', 'deep', 'tint'];
  const hex = (v) => typeof v === 'string' && /^#[0-9a-f]{3,8}$/i.test(v.trim());
  const main = D.querySelector('main[data-template]');
  const locked = R.hasAttribute('data-rv-flavor-lock') || !!(main && /^product/.test(main.dataset.template || ''));

  const apply = (d) => {
    T.forEach((t) => {
      if (hex(d[t])) R.style.setProperty('--rv-flavor-' + t, d[t].trim());
    });
    if (d.handle) R.setAttribute('data-rv-flavor', String(d.handle));
  };

  D.addEventListener('rv:flavor-change', (e) => {
    const d = e.detail || {};
    apply(d);
    if (locked || !d.handle) return;
    try {
      sessionStorage.setItem(K, JSON.stringify({ handle: d.handle, accent: d.accent, deep: d.deep, tint: d.tint }));
    } catch (_) {}
  });

  if (!locked) {
    try {
      const s = JSON.parse(sessionStorage.getItem(K) || 'null');
      if (s && s.handle) apply(s);
    } catch (_) {}
  }

  window.rvFlavor = {
    set: (detail) => D.dispatchEvent(new CustomEvent('rv:flavor-change', { detail })),
  };
})();
